import { render } from "./LaLiturgie.vue?vue&type=template&id=45902ef4&scoped=true&ts=true"
import script from "./LaLiturgie.vue?vue&type=script&lang=ts"
export * from "./LaLiturgie.vue?vue&type=script&lang=ts"

import "./LaLiturgie.vue?vue&type=style&index=0&id=45902ef4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45902ef4"]])

export default __exports__